"use strict";

module.exports = require("./NewRelicAdapter");